export const PKG_NAME = "@hpcc-js/preact-shim";
export const PKG_VERSION = "2.16.6";
export const BUILD_VERSION = "2.104.28";
